"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultPageSize = exports.SORT_ORDER_MINI = exports.SORT_ORDER = exports.SORT_DIRECTIONS = exports.SORT_DIRECTION_DESCEND = exports.SORT_DIRECTION_DESC = exports.SORT_DIRECTION_ASCEND = exports.SORT_DIRECTION_ASC = void 0;
var SORT_DIRECTION_ASC = 'asc';
exports.SORT_DIRECTION_ASC = SORT_DIRECTION_ASC;
var SORT_DIRECTION_ASCEND = 'ascend';
exports.SORT_DIRECTION_ASCEND = SORT_DIRECTION_ASCEND;
var SORT_DIRECTION_DESC = 'desc';
exports.SORT_DIRECTION_DESC = SORT_DIRECTION_DESC;
var SORT_DIRECTION_DESCEND = 'descend';
exports.SORT_DIRECTION_DESCEND = SORT_DIRECTION_DESCEND;
var SORT_DIRECTIONS = [SORT_DIRECTION_ASC, SORT_DIRECTION_DESC];
exports.SORT_DIRECTIONS = SORT_DIRECTIONS;
var SORT_ORDER = [false, SORT_DIRECTION_ASC, SORT_DIRECTION_DESC];
exports.SORT_ORDER = SORT_ORDER;
var SORT_ORDER_MINI = [SORT_DIRECTION_ASC, SORT_DIRECTION_DESC];
exports.SORT_ORDER_MINI = SORT_ORDER_MINI;
var defaultPageSize = 10;
exports.defaultPageSize = defaultPageSize;